import { render } from "./Insurances.vue?vue&type=template&id=4295018c&scoped=true"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"

import "./Insurances.vue?vue&type=style&index=0&id=4295018c&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4295018c"]])

export default __exports__